import { ICreateFolhaPagamentoUseCase } from "../../../presentation/useCases/create/create_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFolhaPagamentoUseCase
 */

export class CreateFolhaPagamentoUseCase implements ICreateFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createFolhaPagamento(
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string,
    tipo: number,
  ): Promise<void> {
    await this.repository.createFolhaPagamento(
      dataCadastro,
      dataPagamento,
      descricao,
      tipo,
    );
  }
}
